import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import * as types from './store/types'
import { mapGetters } from 'vuex'

@Component({
	computed: {
		...mapGetters({
			loading: types.RECIPIENT_LOADING
		})
	}
})
export default class Index extends Vue { }
